const state = {
  cartDisabled: true,
  imgIndex: 0,
  variant: null,
  amount: null
}

export { state }
